import { HtmlTrackingDataExtractor } from './html-tracking-data-extractor';
import { trackEvent, trackView } from '@otto-ec/nexus-registry/pdp/tracking';

const DATA_ATTRIBUTE_CLICK_TRACKING = 'data-ft5-click-tracking';
const DATA_ATTRIBUTE_VIEW_TRACKING = 'data-ft5-view-tracking';

export class HtmlTracking {
    constructor(private trackingDataExtractor: HtmlTrackingDataExtractor) {}

    public init(): void {
        document.documentElement.addEventListener(
            'click',
            (event: MouseEvent) => {
                if (event.target instanceof Element) {
                    this.trackClickWithParentsRecursive(event.target);
                }
            },
            { passive: true, capture: true }
        );
    }

    public onHtmlLoaded(): void {
        const targets = document.querySelectorAll(`[${DATA_ATTRIBUTE_VIEW_TRACKING}]`);
        for (let i = 0; i < targets.length; i++) {
            const data = this.trackingDataExtractor.extractTrackingData(targets[i], DATA_ATTRIBUTE_VIEW_TRACKING);
            if (data) {
                trackView(data);
            }
        }
    }

    /**
 *
 *
 */
    private trackClickWithParentsRecursive(element: Element): void {
        if (element.hasAttribute(DATA_ATTRIBUTE_CLICK_TRACKING)) {
            const data = this.trackingDataExtractor.extractTrackingData(element, DATA_ATTRIBUTE_CLICK_TRACKING);
            if (data) {
                trackEvent(data);
            }
        }
        if (element.parentElement) {
            this.trackClickWithParentsRecursive(element.parentElement);
        }
    }
}
